import {Component, ChangeDetectionStrategy, OnInit, OnDestroy} from "@angular/core";
import {LogCat} from "../../../log/services/log.manager.categories";
import {LogManager} from "../../../log/services/log.manager";

/*
 * Toggle Button Component
 */

@Component({
	selector: 'cp-toggle-button-widget',
	templateUrl: './toggle.button.template.html',
	styleUrls: ['./toggle.button.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})

export class ToggleButtonWidgetComponent implements OnInit, OnDestroy {

	constructor() {
		LogManager.debug(LogCat.UI.ToggleButton, "constructor()");
	}

	ngOnInit(){
		LogManager.debug(LogCat.UI.ToggleButton, "ngOnInit()");
	}

	ngOnDestroy() {
		LogManager.debug(LogCat.UI.ToggleButton, "ngOnDestroy()");
	}
}
